import type { ReminderComposerValue } from '@/components/reminders/ReminderComposer';

// An open new or edit reminder form and everything set in it, kept while the
// window crosses 768px: the phone details page and the wider details panel
// are separate, so this section unmounts and mounts again. In memory only,
// so leaving the details or reloading starts afresh as before.
export interface ReminderDraft {
	mode: 'new' | 'edit';
	id?: string;
	value?: ReminderComposerValue;
	/** The form's Notify panel is open */
	notifyOpen?: boolean;
}

const reminderDrafts = new Map<string, ReminderDraft>();

export const readReminderDraft = (customerId?: string): ReminderDraft | null =>
	(customerId && reminderDrafts.get(customerId)) || null;

export const writeReminderDraft = (customerId: string | undefined, draft: ReminderDraft | null) => {
	if (!customerId) return;
	if (draft) reminderDrafts.set(customerId, draft);
	else reminderDrafts.delete(customerId);
};

/** Saves a form's value, keeping the rest of that same form's draft. */
export const captureReminderDraft = (customerId: string | undefined, draft: ReminderDraft) => {
	const current = readReminderDraft(customerId);
	const sameForm = current?.mode === draft.mode && current.id === draft.id;
	writeReminderDraft(customerId, { ...(sameForm ? current : {}), ...draft });
};

export const captureReminderNotifyOpen = (customerId: string | undefined, notifyOpen: boolean) => {
	const current = readReminderDraft(customerId);
	if (current) writeReminderDraft(customerId, { ...current, notifyOpen });
};
